import Section from './Section'

const SPECS = [
  { label: 'Input', value: 'DXF · DWG · STEP · PDF', note: 'The drawings you already have' },
  { label: 'Operations', value: 'Face · Pocket · Profile · Drill', note: 'Planned by AI' },
  { label: 'Tooling', value: 'Picked per feature', note: 'Feeds and speeds included' },
  { label: 'Output', value: 'Verified G-code', note: 'Checked against your drawing' },
]

/** Spec readout under the hero: four mono-labelled cells, like a controller status line. */
export default function SpecStrip() {
  return (
    <Section>
      <dl className="grid grid-cols-2 lg:grid-cols-4">
        {SPECS.map((s, i) => (
          <div key={s.label} className={`px-5 py-6 md:px-8 ${i % 2 === 1 ? 'border-l' : ''} ${i >= 2 ? 'border-t lg:border-t-0' : ''} ${i === 2 ? 'lg:border-l' : ''} border-white/[0.07]`}>
            <dt className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{s.label}</dt>
            <dd className="mt-2 font-display text-base font-semibold text-slate-100 md:text-lg">{s.value}</dd>
            <dd className="mt-1 font-mono text-[11px] text-slate-500">{s.note}</dd>
          </div>
        ))}
      </dl>
    </Section>
  )
}
